<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Update TAT.</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
</div>
<div class="modal-body">
    <div class="col-md-12">
        <div class="row">
            <div class="card-body" [formGroup]="periodForm">
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-2">
                            <label class="form-label">TAT Type<span class="mandatory">*</span></label>
                            <ng-select id="tatType" placeholder="Select" [items]="tatTypes" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                bindLabel="name" [bindValue]="'id'" formControlName="ddlTATType" >
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="showContract">
                        <div class="mb-2">
                            <label for="chargeCategoryType" class="form-label">Contract Type</label>
                            <ng-select id="chargeCategoryType" placeholder="Select"
                                [items]="contractTypeList" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                formControlName="ddlContractType" bindLabel="name" [bindValue]="'id'"
                                [ngClass]="{'is-invalid': (isModelSubmitted || periodForm.get('ddlContractType')?.touched) && periodForm.get('ddlContractType').errors}" >
                            </ng-select>
                            <div *ngIf="(isModelSubmitted || periodForm.get('ddlContractType')?.touched) && periodForm.get('ddlContractType').errors"
                                class="invalid-feedback">
                                <span *ngIf="periodForm.get('ddlContractType').errors.required">Contract
                                    is Required</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="showCustomer">
                        <div class="mb-2">
                            <label for="CustomerCharge" class="form-label">Customer<span
                                    class="mandatory">*</span></label>
                            <ng-select id="CustomerCharge" [items]="customerList"  [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                placeholder="Select" bindLabel="name"  [bindValue]="'id'" formControlName="ddlCustomer"
                                [ngClass]="{'is-invalid': (isModelSubmitted || periodForm.get('ddlCustomer')?.touched) && periodForm.get('ddlCustomer').errors}" >
                                <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                    <span>{{ item.name }}</span>
                                </ng-template>
                            </ng-select>
                            <div *ngIf="(isModelSubmitted || periodForm.get('ddlCustomer')?.touched) && periodForm.get('ddlCustomer').errors"
                                class="invalid-feedback">
                                <span *ngIf="periodForm.get('ddlCustomer').errors.required">Customer is
                                    Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-2">
                            <label for="fromDate" class="form-label">From Date<span
                                    class="mandatory">*</span></label>
                            <input id="fromDate" class="form-control form-control-sm" type="date"
                                formControlName="txtFromDate" >
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-2">
                            <label for="toDate" class="form-label">To Date<span
                                    class="mandatory">*</span></label>
                            <input id="toDate" class="form-control form-control-sm" type="date"
                                formControlName="txtToDate"
                                [ngClass]="{'is-invalid': (isModelSubmitted || periodForm.get('txtToDate').touched) && periodForm.get('txtToDate').errors}" >
                            <div *ngIf="(isModelSubmitted || periodForm.get('txtToDate').touched) && periodForm.get('txtToDate').errors"
                                class="invalid-feedback">
                                <span *ngIf="periodForm.get('txtToDate').errors.required">Date is
                                    Required</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button title="Update" type="button" class="btn btn-primary " data-dismiss="modal" 
        (click)="updatePeriod()">Update</button>
</div>